export default __webpack_public_path__ + "static/media/programs_usto_got_talent.a085e7cd.svg";